
  <div class="message-panel">
    <div *ngIf="(errorMessage | async)" class="alert alert-danger alert-dismissible" role="alert">
      <button type="button" class="close" (click)="errorMessage=null"><span>&times;</span></button>
      <strong>{{errorMessage | async}}</strong>
    </div>
  </div>

  <div [innerHtml]="termsHtml"></div>
